import axios from 'axios';

let sessionId: string | undefined;
let transactionId: string | undefined;

export const generateId = () => crypto.randomUUID();

export const initSession = () => {
  sessionId = generateId();
  return sessionId;
};

export const getSessionId = () => sessionId;

export const startTransaction = () => {
  transactionId = generateId();
  return transactionId;
};

export const endTransaction = () => {
  transactionId = undefined;
};

export const getTransactionId = () => transactionId;

export const getTransactionContext = () => ({
  ...(sessionId && { sessionId }),
  ...(transactionId && { transactionId }),
});

export const setupTransactionInterceptor = () => {
  axios.interceptors.request.use((reqConfig) => {
    const sid = getSessionId();
    const tid = getTransactionId();

    reqConfig.headers = {
      ...reqConfig.headers,
      'x-external-session-id': sid,
      'x-external-id': tid,
    };

    return reqConfig;
  });
};
